import { useTerminalsStateRE } from "@/States/Terminals";
import { TAB_LABELS } from "@/pages/reporting_v2/constants";
import { ReportingPageContext } from "@/pages/reporting_v2/context";
import {
  REPORTING_TAB_TYPES,
  REPORTING_VIEW_TYPES,
} from "@/pages/reporting_v2/types";
import { useTrans } from "@/translations";

import { useContext, useMemo } from "react";

export const ReportingTableTitle: React.FC = () => {
  const { t } = useTrans();
  const { currentTerminal } = useTerminalsStateRE();

  const { viewType, tabType, selectorLabel } = useContext(ReportingPageContext);

  const headerTextKey = useMemo(
    () => TAB_LABELS[viewType][tabType],
    [viewType, tabType],
  );

  const subHeaderText = useMemo(() => {
    if (viewType === REPORTING_VIEW_TYPES.PORTFOLIO) {
      if (tabType === REPORTING_TAB_TYPES.TOTAL) {
        return `${selectorLabel} · ${t("reportingPage:portfolioTotalGroupedLabel")}`;
      } else if (tabType === REPORTING_TAB_TYPES.INDIVIDUAL) {
        return `${t("reportingPage:portfolioIndividualBreakdownLabel")} · ${selectorLabel}`;
      }
    } else if (viewType === REPORTING_VIEW_TYPES.BUILDING) {
      if (tabType === REPORTING_TAB_TYPES.TOTAL) {
        return `${currentTerminal.name} · ${selectorLabel} · ${t("reportingPage:buildingTotalGroupedLabel")}`;
      } else if (tabType === REPORTING_TAB_TYPES.INDIVIDUAL) {
        return `${t("reportingPage:buildingIndividualBreakdownLabel", { buildingName: currentTerminal.name })} · ${selectorLabel}`;
      }
    }
  }, [viewType, tabType, selectorLabel, t, currentTerminal]);

  return (
    <div>
      <div className="m-0 text-[18px] font-bold text-[#1D1C1C]">
        {t(headerTextKey)}
      </div>
      <div className="text-grey6 mt-[3px] text-[12.5px]">{subHeaderText}</div>
    </div>
  );
};
